var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        {
          staticClass: "pa-0",
          staticStyle: {
            position: "fixed",
            top: "0",
            width: "100%",
            "z-index": "6"
          },
          attrs: { color: "primary" }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", dark: "", color: "primary", dense: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
              _vm._v(" "),
              _c("v-toolbar-title", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.generateMessage(
                        "user_exchanges.create.selectedLogbook"
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "overflow-y-auto",
          staticStyle: { padding: "48px 285px 0 0" },
          style: { background: _vm.$vuetify.theme.themes[_vm.theme].background }
        },
        [
          _c(
            "v-container",
            [
              _c("logbook", {
                on: { itemSelected: _vm.handleItemSelectedClick }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pr-2",
          staticStyle: {
            top: "48px",
            width: "285px",
            overflow: "hidden",
            height: "calc(100% - 48px)",
            left: "auto",
            right: "0",
            "overflow-y": "scroll",
            position: "fixed"
          }
        },
        [_c("logbook-filter")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }